import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";

const NoPageFound = () => {
	
	return (
		<div className="d-flex align-items-center justify-content-center min-vh-100 p-4">
			<div className="text-center" style={{ maxWidth: "600px" }}>
				{/* Content Section */}
				<div className="mb-5">
					<h1
						className="display-1 fw-bold mb-3"
						style={{
							background: "linear-gradient(45deg, #4F46E5, #9333EA)",
							WebkitBackgroundClip: "text",
							WebkitTextFillColor: "transparent",
							letterSpacing: "-2px"
						}}
					>
						404
					</h1>
					<h2 className="h4 fw-semibold text-dark mb-3">Lost in the Clouds?</h2>
					<p className="text-muted mb-4 mx-auto" style={{ maxWidth: "450px" }}>
						The page you're looking for was moved, removed, renamed or might never have existed. Let's get you back on track!
					</p>
				</div>

				{/* Action Buttons */}
				<div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
					<Link
						to="/admin/index"
						className="btn btn-primary btn-lg px-4 d-flex align-items-center justify-content-center gap-2 rounded-pill shadow-sm"
						style={{ minWidth: "180px" }}
					>
						<Home size={18} />
						Back to Home
					</Link>
					<button
						onClick={() => window.history.back()}
						className="btn btn-outline-secondary btn-lg px-4 d-flex align-items-center justify-content-center gap-2 rounded-pill"
						style={{ minWidth: "180px" }}
					>
						<ArrowLeft size={18} />
						Go Back
					</button>
				</div>

				{/* Search Suggestion (Visual only) */}
				<div className="mt-5 pt-4 border-top">
					<p className="small text-muted mb-0 d-flex align-items-center justify-content-center gap-2">
						<Search size={14} />
						Can't find what you need? Try searching in the dashboard.
					</p>
				</div>
			</div>

			<style dangerouslySetInnerHTML={{
				__html: `
        .min-vh-100 { min-height: 80vh !important; }
        .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 4px 15px rgba(79, 70, 229, 0.4) !important; }
        .btn-outline-secondary:hover { transform: translateY(-2px); }
      `}} />
		</div>
	);
};

export default NoPageFound;
